import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

var _this = this;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import { IconChevronLeft } from '@sfx/icons';
import { IconChevronRight } from '@sfx/icons';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { getTransFunc } from '../SFxLocalization';

var prefix = "sfx-react-ui";
var pageSizes = [10, 25, 50, 100, 250];
var defaultBreakWidth = 676;
var defaultPaginationConfig = {
  pageSizes: pageSizes,
  ShowResults: false,
  ShowResultPerPage: false,
  Stretch: false,
  breakWidth: defaultBreakWidth,
  direction: "up"
};

var DefaultPaginationComp = function DefaultPaginationComp(props) {
  var current = props.current,
      hasPrevPage = props.hasPrevPage,
      hasNextPage = props.hasNextPage,
      totalPages = props.totalPages,
      onPageChange = props.onPageChange,
      onCurrentChange = props.onCurrentChange,
      onCurrentBlur = props.onCurrentBlur,
      onCurrentInput = props.onCurrentInput,
      paginationConfig = props.paginationConfig;
  return /*#__PURE__*/React.createElement("div", {
    className: "paginationBox"
  }, hasPrevPage && /*#__PURE__*/React.createElement("span", {
    className: "iconLeftBox",
    onClick: onPageChange.bind(_this, -1)
  }, /*#__PURE__*/React.createElement(IconChevronLeft, {
    size: "18"
  })), !hasPrevPage && /*#__PURE__*/React.createElement("div", {
    className: "iconLeftBox"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pageNum"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pageText"
  }, paginationConfig.pageTextLabel), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "inputBox",
    value: current,
    onChange: onCurrentChange,
    onBlur: onCurrentBlur,
    onKeyPress: onCurrentInput
  }), /*#__PURE__*/React.createElement("span", {
    className: "pageOf"
  }, paginationConfig.ofLabel), /*#__PURE__*/React.createElement("span", null, totalPages)), hasNextPage && /*#__PURE__*/React.createElement("span", {
    className: "iconRightBox",
    onClick: onPageChange.bind(_this, 1)
  }, /*#__PURE__*/React.createElement(IconChevronRight, {
    size: "18"
  })), !hasNextPage && /*#__PURE__*/React.createElement("div", {
    className: "iconRightBox"
  }));
};

var DefaultPageSizeComp = function DefaultPageSizeComp(props) {
  var pageSize = props.pageSize,
      paginationConfig = props.paginationConfig,
      onPageSizeChange = props.onPageSizeChange;
  var pageSizes = paginationConfig.pageSizes,
      resultsPerPageLabel = paginationConfig.resultsPerPageLabel,
      direction = paginationConfig.direction;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownOpen = _useState2[0],
      setDropdown = _useState2[1];

  var sizeChange = function sizeChange(event) {
    onPageSizeChange && onPageSizeChange(Number(event.currentTarget.textContent));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-pageSizeBox")
  }, /*#__PURE__*/React.createElement(Dropdown, {
    className: "".concat(prefix, "-pageSizeDropdown"),
    isOpen: dropdownOpen,
    toggle: function toggle() {
      return setDropdown(!dropdownOpen);
    },
    direction: direction
  }, /*#__PURE__*/React.createElement(DropdownToggle, {
    caret: true,
    className: "toggle"
  }, pageSize), /*#__PURE__*/React.createElement(DropdownMenu, {
    className: "menu"
  }, pageSizes && pageSizes.map(function (size) {
    return /*#__PURE__*/React.createElement(DropdownItem, {
      key: size,
      className: "dropdown-item ".concat(size === pageSize ? 'active' : '', " linked text-white dateRangeMenuItem"),
      onClick: sizeChange
    }, size);
  }))), /*#__PURE__*/React.createElement("span", {
    className: "result"
  }, resultsPerPageLabel));
};

var DefaultTotalResultComp = function DefaultTotalResultComp(props) {
  var totalItems = props.totalItems,
      paginationConfig = props.paginationConfig;
  return /*#__PURE__*/React.createElement("div", {
    className: "totalResult"
  }, /*#__PURE__*/React.createElement("span", null, totalItems), " ", totalItems > 1 ? paginationConfig.resultsLabel : paginationConfig.resultLabel);
};

var PaginationSimple = function PaginationSimple(props) {
  var _props$current = props.current,
      current = _props$current === void 0 ? 1 : _props$current,
      _props$pageSize = props.pageSize,
      pageSize = _props$pageSize === void 0 ? 10 : _props$pageSize,
      _props$total = props.total,
      total = _props$total === void 0 ? 0 : _props$total,
      remark = props.remark,
      width = props.width,
      onChange = props.onChange,
      onChangeResultsPerPage = props.onChangeResultsPerPage,
      _props$PageSizeComp = props.PageSizeComp,
      PageSizeComp = _props$PageSizeComp === void 0 ? DefaultPageSizeComp : _props$PageSizeComp,
      _props$PaginationComp = props.PaginationComp,
      PaginationComp = _props$PaginationComp === void 0 ? DefaultPaginationComp : _props$PaginationComp,
      _props$TotalResultCom = props.TotalResultComp,
      TotalResultComp = _props$TotalResultCom === void 0 ? DefaultTotalResultComp : _props$TotalResultCom,
      transInstance = props.transInstance;
  var trans = getTransFunc(transInstance);

  var paginationConfig = _objectSpread(_objectSpread({}, defaultPaginationConfig), {}, {
    pageTextLabel: trans("SFxPage"),
    ofLabel: trans("SFxOf"),
    resultsLabel: trans("SFxResults"),
    resultLabel: trans("SFxResult"),
    resultsPerPageLabel: trans("SFxResultsPerPage")
  }, props.paginationConfig);

  var totalPages = Math.ceil(total / pageSize);

  var _useState3 = useState(current),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  useEffect(function () {
    setCurrentPage(current);
  }, [current]);
  useEffect(function () {
    if (totalPages > 0 && current > 1 && current > totalPages) {
      onChange && onChange(totalPages);
    }
  }, [totalPages, current, onChange]);

  var onPageChange = function onPageChange(value) {
    var newPage = current + value;
    onChange && onChange(newPage);
    setCurrentPage(newPage);
  };

  var getCurrentPage = function getCurrentPage(value) {
    var page = Number.parseInt(value);
    page = page ? page : 1;
    page = page > totalPages ? totalPages : page;
    return page;
  };

  var onCurrentChange = function onCurrentChange(e) {
    var value = Number.parseInt(e.target.value);

    if (isNaN(value)) {
      setCurrentPage('');
    } else {
      setCurrentPage(value);
    }
  };

  var onCurrentInput = function onCurrentInput(e) {
    // user hits an enter to go to a specific page
    if (e.charCode === 13) {
      var page = getCurrentPage(e.target.value);
      setCurrentPage(page);
      onChange && onChange(page);
      e.target.blur();
    }
  };

  var onCurrentBlur = function onCurrentBlur(e) {
    var page = getCurrentPage(e.target.value);
    setCurrentPage(page);
    onChange && onChange(page);
  };

  var hasNextPage = current < totalPages;
  var hasPrevPage = current > 1;
  var stretch = paginationConfig.Stretch ? {
    flex: 1,
    display: 'flex',
    justifyContent: 'center'
  } : {}; // When the following conditions are all met, use mobile mod pagination layout
  // (1). Container width < 676px. (2). Show 'Results per page'.(3). Show pagination with previous or next page.

  var containerWidth = width || window.innerWidth;
  var useMobileDeviceSize = paginationConfig.breakWidth && containerWidth < paginationConfig.breakWidth && paginationConfig.ShowResultPerPage && (hasNextPage || hasPrevPage);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !useMobileDeviceSize && /*#__PURE__*/React.createElement("div", {
    id: "paginationSimple".concat(remark ? remark : ''),
    className: "d-flex justify-content-between align-items-center ".concat(prefix, "-pageBox")
  }, paginationConfig.ShowResultPerPage && /*#__PURE__*/React.createElement(PageSizeComp, _extends({}, props, {
    onPageSizeChange: onChangeResultsPerPage,
    pageSize: pageSize,
    paginationConfig: paginationConfig
  })), /*#__PURE__*/React.createElement("div", {
    style: stretch
  }, (hasNextPage || hasPrevPage) && /*#__PURE__*/React.createElement(PaginationComp, _extends({}, props, {
    current: currentPage,
    hasPrevPage: hasPrevPage,
    hasNextPage: hasNextPage,
    totalPages: totalPages,
    onPageChange: onPageChange,
    onCurrentChange: onCurrentChange,
    onCurrentBlur: onCurrentBlur,
    onCurrentInput: onCurrentInput,
    paginationConfig: paginationConfig
  }))), paginationConfig.ShowResults && /*#__PURE__*/React.createElement(TotalResultComp, _extends({}, props, {
    totalItems: Number(total),
    paginationConfig: paginationConfig
  }))), useMobileDeviceSize && /*#__PURE__*/React.createElement("div", {
    id: "paginationSimple".concat(remark ? remark : ''),
    className: "".concat(prefix, "-mobileDevicePageBox")
  }, /*#__PURE__*/React.createElement("div", {
    style: stretch,
    className: "pageTop"
  }, (hasNextPage || hasPrevPage) && /*#__PURE__*/React.createElement(PaginationComp, _extends({}, props, {
    current: currentPage,
    hasPrevPage: hasPrevPage,
    hasNextPage: hasNextPage,
    totalPages: totalPages,
    onPageChange: onPageChange,
    onCurrentChange: onCurrentChange,
    onCurrentBlur: onCurrentBlur,
    onCurrentInput: onCurrentInput,
    paginationConfig: paginationConfig
  }))), /*#__PURE__*/React.createElement("div", {
    className: "pageBottom"
  }, paginationConfig.ShowResultPerPage && /*#__PURE__*/React.createElement(PageSizeComp, _extends({}, props, {
    pageSize: pageSize,
    onPageSizeChange: onChangeResultsPerPage,
    paginationConfig: paginationConfig
  })), paginationConfig.ShowResults && /*#__PURE__*/React.createElement(TotalResultComp, _extends({}, props, {
    totalItems: Number(total),
    paginationConfig: paginationConfig
  })))));
};

export default PaginationSimple;